import toast from "react-hot-toast";

import { FileIcon } from "lucide-react";

import { FileChooserWithDropzone } from "components/lib/Choosers";
import { UploadedFilesTable } from "components/lib/UploadedFilesTable";

import { FieldProps, IdeaFileValue } from "./FieldProps";

const File = ({
  field,
  ideaId,
  fieldValue,
  updateIdea,
  isEditing,
}: FieldProps) => {
  const fileValue = fieldValue as IdeaFileValue | null;
  const files = fileValue
    ? [{ id: fileValue.value, name: fileValue.name, url: fileValue.value }]
    : [];

  if (!isEditing) {
    return <UploadedFilesTable files={files} />;
  }

  if (files.length !== 0) {
    return (
      <UploadedFilesTable
        files={files}
        onRemove={() => updateIdea(null, ["templated", field.id])}
      />
    );
  }

  return (
    <div>
      <FileChooserWithDropzone
        forType="idea"
        forId={ideaId}
        onComplete={(_id: unknown, fileName: string, imageSrc: string) => {
          updateIdea({ value: imageSrc, name: fileName }, [
            "templated",
            field.id,
          ]);
        }}
        onError={toast.error}
        popupProps={{ position: "bottom center" }}
        dropzoneProps={{ title: "Upload a file", defaultIcon: FileIcon }}
      />
    </div>
  );
};

export default File;
